import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Header } from 'semantic-ui-react';
import server from '../../functions/server';
import userId from '../../functions/userid';
import $ from 'jquery';

export default class EditPincode extends React.Component {
  state = {
    open: false,
    pincode: ""
  };

  handleClose = () => {
    this.props.handleState({editpincode: false});
  };

  handleUpdate = () => {
    let pincode = this.state.pincode.trim();
    if (pincode.length < 2) {
      this.setState({
        message: "Invalid pincode"
      });
      return;
    }
    let data = {
      id: this.props.id,
      owner: userId(),
      type: 'pincode',
      value: pincode
    }
    console.log(data);
    let context = this;
    $.ajax({
      type: 'POST',
      url: server() + "/shop/update.php",
      data: data,
      beforeSend: function(x) {
          context.setState({
            dimmer: true,
            loadText: "Updating Mobile Number"
          });
      },
      success: function(data, status) {
        let editpincode = true;
        if (data == "1") {
          context.props.updateProps('pincode', pincode);
          editpincode = false;
        }
        context.props.handleState({
          dimmer: false,
          loadText: "", editpincode

        });
      },
      error: function(data, status) {
        context.props.handleState({
          dimmer: false,
          loadText: "",
          message: data
        });
      }
    });
  }

  render() {
    if (!this.state.pincode) {
      this.setState({
        pincode: this.props.pincode
      })
    }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Update pincode Number</DialogTitle>
          <DialogContent>
            <DialogContentText>
              pincode Number
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="descriptionText"
              value={this.state.pincode}
              onChange={(e) => {this.setState({pincode: e.target.value, message:""})}}
              fullWidth
            />
            <Header as='h4' color='red'>
              {this.state.message}
            </Header>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleUpdate} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
